import { FC, memo } from "react";
import { MatchStatus } from "service";
import styled from "styled-components";
import { SIDE } from "_constants";
import { getTeamColors } from "components/colors";

export const AttackIndicator: FC<{ status: MatchStatus }> = memo(
  ({ status: { x, y, sc, nsc, side, ...status } }) => {
    if (!x || !y) return <></>;

    const { home, away } = getTeamColors(status as any);
    const fillColor = side === SIDE.HOME ? home : away;

    return (
      <>
        <PathContainer className="attack-indicator" side={side}>
          <svg width="100%" height="100%" viewBox="0 0 400 180">
            <defs>
              <linearGradient
                id="gradient"
                x1="0"
                y1="0.5"
                x2="1"
                y2="0.5"
                opacity={0.8}
              >
                <stop offset="0" stopColor={fillColor} stopOpacity="0.4" />
                <stop offset="0.5" stopColor={fillColor} stopOpacity="0.4" />
                <stop
                  offset="1"
                  stopColor={fillColor}
                  stopOpacity={`${
                    0.6 +
                    0.5 *
                      Math.max((x - 0.6) * (side === SIDE.HOME ? 1 : -1), 0) *
                      2
                  }`}
                />
              </linearGradient>
            </defs>

            <RotGroup data-side={side}>
              <AttackPath
                data-side={side}
                x={x}
                style={{ opacity: "0.7" }}
                fill="url(#gradient)"
                d="M2,2 L390,2 L420,90 L390,178 L2,178 Z"
              />
            </RotGroup>
          </svg>
        </PathContainer>
      </>
    );
  }
);

const PathContainer = styled.div<{ side?: SIDE }>`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  padding-bottom: ${(p) => (p.side === SIDE.AWAY ? "1vw" : "0")};

  & > svg {
    width: 99%;
    height: 100%;
    display: block;
  }
`;

const RotGroup = styled.g`
  transition: none; /* side change should not animate rotation */
  transform-origin: 200px 90px; /* center of 400x180 viewBox */
  transform-box: fill-box;

  &[data-side="2"] {
    transform: rotate(180deg);
  }
`;

const AttackPath = styled.path<{ x: number }>`
  transform: translateX(${(props) => props.x * 400 - 400 + 17}px);
  transform-origin: 50% 50%;
  transition: transform 1s ease; /* translate animates */
  &[data-side="2"] {
    transform: translateX(${(props) => props.x * 400 - 17}px);
  }
`;
